import React from 'react';
import { useApp } from '../../context/Store';
import SafeIcon from '../../common/SafeIcon';
import { FiCpu, FiX, FiInfo, FiAlertCircle } from 'react-icons/fi';
import Badge from '../ui/Badge';

export default function AIPanel() {
  const { isAIPanelOpen, toggleAIPanel } = useApp();

  if (!isAIPanelOpen) return null;

  return (
    <div className="w-80 bg-white border-l border-slate-200 flex flex-col h-full shadow-[-4px_0_15px_-3px_rgba(0,0,0,0.05)]">
      <div className="p-4 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2 font-medium text-purple-900">
          <SafeIcon icon={FiCpu} />
          Contribution Assistant
        </div>
        <button onClick={toggleAIPanel} className="text-slate-400 hover:text-slate-600">
          <SafeIcon icon={FiX} />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        
        <div className="space-y-2">
          <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Contextual Insight</h4>
          <div className="bg-purple-50 border border-purple-100 rounded-md p-3 text-sm text-purple-800 leading-relaxed">
            Based on recent signals, your team is focusing heavily on top-of-funnel metrics, but customer retention signals are showing a 15% discrepancy.
          </div>
        </div>

        <div className="space-y-3">
          <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Considerations</h4>
          
          <div className="flex gap-3 items-start">
            <SafeIcon icon={FiInfo} className="text-blue-500 mt-0.5 shrink-0" />
            <p className="text-sm text-slate-700">How does this approach align with last quarter's decision to prioritize enterprise clients?</p>
          </div>
          
          <div className="flex gap-3 items-start">
            <SafeIcon icon={FiAlertCircle} className="text-amber-500 mt-0.5 shrink-0" />
            <div className="space-y-1">
              <p className="text-sm text-slate-700">Contradictory evidence detected.</p>
              <Badge variant="risk">View conflicting signals</Badge>
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Sources</h4>
          <ul className="text-sm text-slate-600 space-y-1">
            <li className="flex items-center gap-2 hover:text-blue-600 cursor-pointer">
              <span className="w-1 h-1 rounded-full bg-slate-300"></span>
              Q2 Strategy Review (Confirmed)
            </li>
            <li className="flex items-center gap-2 hover:text-purple-600 cursor-pointer">
              <span className="w-1 h-1 rounded-full bg-slate-300"></span>
              Analytics Agent Report (Inferred)
            </li>
          </ul>
        </div>
      </div>

      <div className="p-4 border-t border-slate-200 bg-slate-50">
        <p className="text-xs text-slate-500 text-center">
          AI suggests context. Human judgment decides.
        </p>
      </div>
    </div>
  );
}